module.exports = __webpack_public_path__ + "static/webinar2_notes-987ef3b786ac4ecc38e70fe6dfd90dbb.pdf";